import type {
  TNavigationTreeDetailCreateForm,
  TNavigationTreeDetailEditForm,
} from 'core/model/interfaces/navigation/navigation.interface';
import { navigationData } from './navigation.data';
import { IGetNavigationTreeParams } from './navigation.dto';
import {
  priceGroupsDTO,
  toFormDataFromNavigationTreeForm,
  toINavigationTreeDetail,
  toINavigationTreeItems,
} from './navigation.mappers';

export const navigationService = {
  getNavigationTrees: async (params?: IGetNavigationTreeParams) => {
    const response = await navigationData.getNavigationTrees(params ?? {});
    return toINavigationTreeItems(response);
  },

  getNavigationPriceGroups: async (navigationId?: number) => {
    const response = await navigationData.getNavigationPriceGroups(navigationId);
    const mappedResponse = priceGroupsDTO(response);
    return mappedResponse;
  },

  getNavigationTreeById: async (id: number) => {
    const result = await navigationData.getNavigationTreeDetailById(id);
    return toINavigationTreeDetail(result);
  },

  createNavigationTree: async (data: TNavigationTreeDetailCreateForm) => {
    const formData = toFormDataFromNavigationTreeForm(data);
    return navigationData.createNavigationTree(formData);
  },

  editNavigationTree: (data: TNavigationTreeDetailEditForm) => {
    const formData = toFormDataFromNavigationTreeForm(data);
    return navigationData.editNavigationTree(data.id, formData as unknown as FormData);
  },

  deleteNavigationTree: (id: number) => navigationData.deleteNavigationTree(id),

  duplicateNavigationTree: (data: TNavigationTreeDetailEditForm) => {
    const formData = toFormDataFromNavigationTreeForm(data, data.id);
    return navigationData.duplicateNavigationTree(formData as unknown as FormData);
  },
};
